import { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { websiteUrl } from "../constants/config";
import { SurveyShareButtonProps } from "../pages/view-survey/components/share-survey-button.component";
import { showNotification } from "../redux/notification/notification.slice";
import { useShareSurveyResultsMutation } from "../redux/survey/survey.endpoints";
import { useCopy } from "./useCopy";
import ErrorLogService from "../services/error-log/error-log.service";

const copySuccessMessage = 'Publicly shareable RTR preview link was successfully copied to clipboard';

interface UseShareRTRReturn {
  readonly onRTRShare: () => void;
}

const useShareRTR = ({ surveyId }: SurveyShareButtonProps): UseShareRTRReturn => {
  const shareUrl = useRef('');
  const [shareRTR, { data, error, isError }] = useShareSurveyResultsMutation();
  const { toClipboard } = useCopy();
  const dispatch = useDispatch();

  useEffect(() => {
    if (data && !shareUrl.current) {
      shareUrl.current = createUrl(data);
    }

    shareUrl.current && void toClipboard(shareUrl.current, copySuccessMessage);
  }, [data]);

  useEffect(() => {
    if (isError) {
      dispatch(showNotification({ theme: 'warning', summary: 'Something went wrong. Please try again.' }));
      ErrorLogService.logError(error ?? 'Share RTR error', 'useShareRTR', 'useEffect-isError');
    }
  }, [isError]);

  function onRTRShare(): void {
    const url = window.location.href;

    if (url.indexOf('share-id') >= 0 ? url : '') {
      shareUrl.current = url;
    }

    if (shareUrl.current) {
      toClipboard(shareUrl.current, copySuccessMessage);
    } else {
      surveyId && void shareRTR(surveyId);
    }
  }

  function createUrl(shareId: string): string {
    return `${websiteUrl}/share-rtr?share-id=${shareId}`;
  }

  return {
    onRTRShare,
  };
};

export default useShareRTR;
